<div class="modal-header has-close">
  <div class="modal-title" ngbAutofocus>
    <span>Change password</span>
  </div>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-6">
      <div class="password-requirements-wrapper" *ngIf="!globals.isMobile">
        <div class="title">Password requirements</div>
        <div class="requirements">
          <div
            class="check-icon"
            [class.check]="isAtLeast8Characters"
            [class.uncheck]="!isAtLeast8Characters"
          ></div>
          At least 8 characters
        </div>
        <div class="requirements">
          <div
            class="check-icon"
            [class.check]="hasNumber"
            [class.uncheck]="!hasNumber"
          ></div>
          At least 1 number
        </div>
        <div class="requirements">
          <div
            class="check-icon"
            [class.check]="hasSpecialCharacter"
            [class.uncheck]="!hasSpecialCharacter"
          ></div>
          At least 1 special character
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="password-form-wrapper">
        <form id="form-login" [formGroup]="changePasswordForm">
          <div class="field-wrapper">
            <label>
              <span>New password</span>
              <input
                [class.invalid-input]="
                  this.newPasswordControl.touched &&
                  !(hasSpecialCharacter && isAtLeast8Characters && hasNumber)
                "
                type="password"
                formControlName="newPassword"
                required
              />
            </label>
            <!--      Value: {{ emailAddress.value }}-->
            <!--      Error: {{ emailAddress.errors | json }}-->
            <!--      Dirty: {{ emailAddress.dirty | json }}-->
            <span
              class="error"
              *ngIf="
                this.newPasswordControl.touched &&
                !(hasSpecialCharacter && isAtLeast8Characters && hasNumber)
              "
            >
              Password does not meet the requirements
            </span>
          </div>

          <div class="password-requirements-wrapper" *ngIf="globals.isMobile">
            <div class="title">Password requirements</div>
            <div class="requirements">
              <div
                class="check-icon"
                [class.check]="isAtLeast8Characters"
                [class.uncheck]="!isAtLeast8Characters"
              ></div>
              At least 8 characters
            </div>
            <div class="requirements">
              <div
                class="check-icon"
                [class.check]="hasNumber"
                [class.uncheck]="!hasNumber"
              ></div>
              At least 1 number
            </div>
            <div class="requirements">
              <div
                class="check-icon"
                [class.check]="hasSpecialCharacter"
                [class.uncheck]="!hasSpecialCharacter"
              ></div>
              At least 1 special character
            </div>
          </div>

          <div class="field-wrapper">
            <label>
              <span>Confirm password</span>
              <input
                [class.invalid-input]="
                  this.confirmPasswordControl.touched && !isPasswordMatch
                "
                type="password"
                formControlName="confirmPassword"
                required
              />
            </label>
            <span
              class="error"
              *ngIf="this.confirmPasswordControl.touched && !isPasswordMatch"
            >
              Passwords do not match
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <app-primary-button
    (click)="onChangePassword()"
    [disabled]="
      !(
        isPasswordMatch &&
        hasSpecialCharacter &&
        isAtLeast8Characters &&
        hasNumber
      )
    "
    >Change password
  </app-primary-button>
</div>
